import React from "react";
import { FormGroup, Input, Label } from "reactstrap";

function SelectInput(props) {
  const { label, options, className, placeholder = '--select--' } = props;
  return (
    <FormGroup>
      {label && label !== "" ? (
        <Label className="font-weight-bold">{label}</Label>
      ) : null}
      <Input
        type="select"
        className={`form-control-alternative border border-success ${className}`}
        {...props}
      >
      {props.value? <option>{props.value}</option>: <option value=''>{placeholder}</option>}
        {options.map((item, index) => (
          <option key={index} value={item}>
            {item}
          </option>
        ))}
      </Input>
    </FormGroup>
  );
}

export default SelectInput;
